import type { CharacterAttributes, CharacterInput } from "@/features/characters/types";

export const ancestryOptions = [
  "Humano",
  "Anão",
  "Dahllan",
  "Elfo",
  "Goblin",
  "Lefou",
  "Minotauro",
  "Qareen",
  "Golem",
  "Hynne",
  "Sílfide",
  "Trog",
].map((value) => ({ label: value, value }));

export const classOptions = [
  "Arcanista",
  "Bárbaro",
  "Bardo",
  "Caçador",
  "Clérigo",
  "Druida",
  "Guerreiro",
  "Inventor",
  "Ladino",
  "Nobre",
  "Paladino",
].map((value) => ({ label: value, value }));

export const originOptions = [
  "Acólito",
  "Artesão",
  "Criminoso",
  "Ermitão",
  "Guarda",
  "Herói Camponês",
  "Mercador",
  "Nobre",
  "Soldado",
].map((value) => ({ label: value, value }));

export const attributeLabels: Array<keyof CharacterAttributes> = [
  "força",
  "destreza",
  "constituição",
  "inteligência",
  "sabedoria",
  "carisma",
];

export function createDefaultCharacterInput(): CharacterInput {
  return {
    name: "",
    epithet: "",
    ancestry: ancestryOptions[0].value,
    className: classOptions[0].value,
    origin: originOptions[0].value,
    level: 1,
    summary: "",
    goals: "",
    equipment: "",
    notes: "",
    attributes: {
      força: 10,
      destreza: 10,
      constituição: 10,
      inteligência: 10,
      sabedoria: 10,
      carisma: 10,
    },
  };
}
